/**
 * Safely check if requires_payment is truthy.
 * Handles boolean, string ("0"/"1"/"true"/"false"), number (0/1), null, undefined.
 */
export function isPaymentRequired(value) {
  if (value === false || value === 0 || value === '0' || value === 'false') return false;
  if (value === null || value === undefined) return false;
  return true;
}
